// extracted by mini-css-extract-plugin
export default {"cls1":"NavigationDrawerOperatingAsItem-Name_cls1__DChGv","cls2":"NavigationDrawerOperatingAsItem-Name_cls2__2w9cI NavigationDrawerOperatingAsItem-Name_cls1__DChGv"};